import React from 'react';
import './header.css';
import { NavLink as Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { AppState } from '../../store';


const mapDispatchToProps = dispatch => {
    return {
    }
}

const mapStateToProps = (state: AppState) => ({

})

class AppHeader extends React.Component<any> {
    componentDidMount() {

    }

    render() {
        return (
            <div className="app__header">
                {this.props.children}
                <span style={{margin: '0 auto'}}>User Management</span>
            </div>
        )
    }

}

export default connect(mapStateToProps, mapDispatchToProps)(AppHeader);